import type { AppRouteRecordRaw } from "shared/types";
import {
  LAYOUTS,
  MANAGER_ROLES,
  MEETING_OVERVIEW_ROLES,
  MODULE_SETTINGS,
} from "shared/constants";
import { ADVISORY_ROUTE_NAMES } from "meetings/advisory/routes/routeNames";

export const transitionMeetingManageFragment: AppRouteRecordRaw[] = [
  {
    path: "transition-meeting",
    component: () => import("views/EmptyView.vue"),
    meta: {
      title: "Adviesbespreking beheren",
      roleRequired: MANAGER_ROLES,
      settingRequired: [MODULE_SETTINGS.TRANSITION_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    children: [
      {
        path: "create",
        name: ADVISORY_ROUTE_NAMES.CREATE,
        component: () =>
          import("meetings/advisory/pages/teacher/TransitionMeetingCreatePage.vue"),
        meta: {
          title: "Adviesbespreking toevoegen",
          roleRequired: MANAGER_ROLES,
          settingRequired: [MODULE_SETTINGS.TRANSITION_MEETING],
          hideSubmenu: true,
        },
      },
      {
        path: "edit/:id",
        name: ADVISORY_ROUTE_NAMES.EDIT,
        component: () =>
          import("meetings/advisory/pages/teacher/TransitionMeetingEditPage.vue"),
        meta: {
          title: "Bespreking bewerken",
          roleRequired: MANAGER_ROLES,
          settingRequired: [MODULE_SETTINGS.TRANSITION_MEETING],
          hideSubmenu: true,
        },
      },
      {
        path: ":id",
        name: ADVISORY_ROUTE_NAMES.MANAGE,
        component: () =>
          import("meetings/advisory/pages/teacher/ManageTransitionMeetingPage.vue"),
        meta: {
          // Read-only for a teamleader; the page hides its manage actions for
          // them. Widens the parent's MANAGER_ROLES for this leaf only.
          roleRequired: MEETING_OVERVIEW_ROLES,
          // isAuthorized() reads settingRequired off the deepest matched record
          // only, so a leaf that omits it loses its parent's module gate.
          settingRequired: [MODULE_SETTINGS.TRANSITION_MEETING],
          hideSubmenu: true,
        },
      },
    ],
  },
];
